import apiUrl from '../../../../../utils/settings';

export const StaffInsurancesUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/staff-insurance';
};
export const StaffInsuranceBeneficiaryUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/staff-insurance/beneficiary';
};
export const StaffInsurancesNomineeUrl = () => {
    return apiUrl + '/v2/benefit-beneficiary/staff-insurance/nominee';
};
export const AdhaarOCRVerificationUrl = () => {
    return apiUrl + '/user-pan-and-gst/ocr-document?document_type=AADHAAR';
};
export const PanOCRVerificationUrl = () => {
    return apiUrl + '/user-pan-and-gst/ocr-document?document_type=PAN';
};







